import { useState, useEffect } from 'react';
import { DollarSign, TrendingUp, Calendar, CheckCircle, Clock, Loader2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import config from '../config';

export const InstallerEarningsPage = () => {
  const [loading, setLoading] = useState(true);
  const [earnings, setEarnings] = useState({
    total_earned: 0,
    pending_payment: 0,
    completed_projects: 0,
    monthly_earnings: [],
    transactions: []
  });

  useEffect(() => {
    fetchEarnings();
  }, []);

  const fetchEarnings = async () => {
    try {
      const token = localStorage.getItem('access_token');
      const response = await fetch(config.getApiUrl('/marketplace/installer/earnings/'), {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setEarnings(data);
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const stats = [
    { label: 'کل درآمد', value: earnings.total_earned, icon: DollarSign, color: 'bg-green-500' },
    { label: 'در انتظار پرداخت', value: earnings.pending_payment, icon: Clock, color: 'bg-yellow-500' },
    { label: 'پروژه تکمیل شده', value: earnings.completed_projects, icon: CheckCircle, color: 'bg-blue-500' },
  ];

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-10 h-10 animate-spin text-blue-600" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">درآمد و تسویه حساب</h1>
        
        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {stats.map((stat) => (
            <div key={stat.label} className="bg-white rounded-xl shadow-sm p-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-gray-500 text-sm">{stat.label}</p>
                  <p className="text-2xl font-bold text-gray-900 mt-1">
                    {stat.value.toLocaleString()} تومان
                  </p>
                </div>
                <div className={`${stat.color} p-3 rounded-full text-white`}>
                  <stat.icon className="w-6 h-6" />
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Transactions */}
        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
          <div className="p-6 border-b border-gray-200">
            <h2 className="text-xl font-bold">تراکنش‌های اخیر</h2>
          </div>
          
          {earnings.transactions.length === 0 ? (
            <div className="p-12 text-center text-gray-500">
              <DollarSign className="w-16 h-16 text-gray-300 mx-auto mb-4" />
              <p>هیچ تراکنشی یافت نشد</p>
            </div>
          ) : (
            <div className="divide-y divide-gray-200">
              {earnings.transactions.map((transaction, idx) => (
                <div key={idx} className="p-4 flex justify-between items-center">
                  <div>
                    <p className="font-medium">{transaction.description}</p>
                    <p className="text-sm text-gray-500">{new Date(transaction.date).toLocaleDateString('fa-IR')}</p>
                  </div>
                  <div className={`font-bold ${transaction.type === 'credit' ? 'text-green-600' : 'text-red-600'}`}>
                    {transaction.type === 'credit' ? '+' : '-'}{transaction.amount.toLocaleString()} تومان
                  </div>
                </div>
              ))}
            </div>
          )}
          
          <div className="p-4 border-t border-gray-200">
            <Link to="/installer/withdraw" className="block w-full text-center bg-green-600 text-white py-3 rounded-lg font-bold hover:bg-green-700">
              درخواست تسویه حساب
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
